/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ObservationGroupType {
  HeartAndBloodPressure = 'HeartAndBloodPressure',
  SleepAndRecovery = 'SleepAndRecovery',
  ActivityAndMovement = 'ActivityAndMovement',
  MetabolicAndWeight = 'MetabolicAndWeight',
  MindAndMood = 'MindAndMood'
}
